module.exports = __webpack_public_path__ + "img/WechatIMG268.19e00084.png";